<template>
    <div>
        <!-- customer added alert -->
        <v-snackbar top v-model="customerAddedMessage" color="green" class="pl-10">
            <v-icon>mdi-check-circle-outline</v-icon> <span class="font-weight-bold">The customer and the basebase have been created!</span>
        </v-snackbar>
        <!-- not allowed alert -->
        <v-snackbar top v-model="errorMessage" color="red" class="pl-10">
            <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold">An error occured! Please stop and contact the support!</span>
        </v-snackbar>
        <!-- no valid domain alert -->
        <v-snackbar top v-model="noValidDomainMessage" color="red" class="pl-10">
            <v-icon>mdi-alert-circle-outline</v-icon> <span class="font-weight-bold">please provide a valid domain (e.g. test.de)!</span>
        </v-snackbar>
        <form @submit.prevent="addCustomer" autocomplete="off">
            <v-text-field v-model="customerName" color="primary" label="Company..." prepend-icon="mdi-office-building-outline" @blur="fillTextfields" required />
            <v-text-field
                v-model="domain"
                color="primary"
                label="Domains (e.g. searchinsights.de,quaro.io) - mehrere Domains nur mit Komma, OHNE Leertaste trennen wie vorgegeben"
                @blur="
                    sanitizeCustomerName()
                    fillTextfields()
                "
                prepend-icon="mdi-email"
            />
            <v-select :items="plans" v-model="plan" item-text="text" item-value="value" return-object label="Plan..." prepend-icon="mdi-account-group"></v-select>
            <v-select :items="stati" v-model="status" item-text="text" item-value="value" return-object label="Status..." prepend-icon="mdi-account-group"></v-select>
            <v-text-field v-model="dbName" color="secondary" label="Database name..." prepend-icon="mdi-refresh" required />
            <v-text-field v-model="dbUsername" color="secondary" label="Database username..." prepend-icon="mdi-refresh" required />
            <v-text-field v-model="dockerName" color="secondary" label="Docker name..." prepend-icon="mdi-refresh" required />
            <v-text-field v-model="port" color="secondary" label="Port..." prepend-icon="mdi-refresh" required />
            <v-text-field v-model="credits" color="secondary" label="Credits..." prepend-icon="mdi-refresh" required />
            <v-btn :disabled="btnDisabled" color="primary" outlined type="submit">
                Create Company &amp; Database
            </v-btn>
        </form>
    </div>
</template>
<script>
    export default {
        data: () => ({
            /**********************************************************
             * Create Company:
             **********************************************************/
            auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
            customerName: "",
            domain: "",
            plan: "",
            credits: 150,
            plans: [
                { value: 0, text: "O - Research & Monitoring" },
                { value: 1, text: "1 - Research" }
            ],
            plan: { value: 1, text: "1 - Research" },
            stati: [
                { value: "testing", text: "1 - testing" },
                { value: "active", text: "2 - active" },
                { value: "paused", text: "3 - paused" },
                { value: "stopped", text: "4 - stopped" },
                { value: "inactive", text: "5 - inactive" }
            ],
            status: { value: "testing", text: "1 - testing" },
            dbName: "",
            dbUsername: "",
            dockerName: "",
            port: "",
            btnDisabled: false,
            errorMessage: false,
            customerAddedMessage: false,
            noValidDomainMessage: false
        }),
        methods: {
            sanitizeCustomerName() {
                this.customerName = (this.customerName || "").replace(/[^a-zA-Z0-9äöüÄÖÜß ._\-&,/()']/gu, "")
            },
            addCustomer() {
                let domains = this.domain.split(",")
                this.btnDisabled = true
                let dbObject = {
                    customerName: this.customerName,
                    domain: JSON.stringify(domains),
                    plan: this.plan.value,
                    status: this.status.value,
                    dbUsername: this.dbUsername,
                    dbName: this.dbName,
                    dockerName: this.dockerName,
                    port: this.port,
                    credits: this.credits,
                    campaign: "manual",
                    newsletter: 0,
                    testing_payment_duration: ""
                }
                console.log(dbObject)
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/admin/server/db/create", dbObject, { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response)
                        this.customerAddedMessage = true
                        this.customerName = ""
                        this.domain = ""
                        this.dbUsername = ""
                        this.dbName = ""
                        this.dockerName = ""
                        this.fetchPort()
                        this.btnDisabled = false
                    })
                    .catch((error) => {
                        console.log(error)
                        this.btnDisabled = false
                        this.errorMessage = true
                    })
            },
            fetchPort() {
                this.$http
                    .get(process.env.VUE_APP_APIURL + "/admin/server/db/nextport", { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response.body)
                        this.port = response.body
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            fillTextfields() {
                let name = ""

                try {
                    if (this.domain.length > 0) {
                        let domainsplits = this.domain.split(".")
                        if (domainsplits.length > 1) {
                            name = domainsplits[0]
                        } else {
                            this.noValidDomainMessage = true
                            this.domain = ""
                            let value = this.customerName.toLowerCase()
                            value = value.replace(/ä/g, "ae")
                            value = value.replace(/ö/g, "oe")
                            value = value.replace(/ü/g, "ue")
                            value = value.replace(/ß/g, "ss")
                            value = value.replace(/ /g, "-")
                            value = value.replace(/\./g, "")
                            value = value.replace(/,/g, "")
                            value = value.replace(/\(/g, "")
                            value = value.replace(/\)/g, "")
                            name = value
                        }
                    } else {
                        let value = this.customerName.toLowerCase()
                        value = value.replace(/ä/g, "ae")
                        value = value.replace(/ö/g, "oe")
                        value = value.replace(/ü/g, "ue")
                        value = value.replace(/ß/g, "ss")
                        value = value.replace(/ /g, "-")
                        value = value.replace(/\./g, "")
                        value = value.replace(/,/g, "")
                        value = value.replace(/\(/g, "")
                        value = value.replace(/\)/g, "")
                        name = value
                    }
                } catch (error) {
                    this.noValidDomainMessage = true
                    this.domain = ""
                }
                this.dbName = name.replace(/-/g, "")
                this.dbName = name.replace(/&/g, "")
                this.dbUsername = "dbuser_" + name.replace(/-/g, "")
                this.dbUsername = this.dbUsername.replace(/&/g, "")
                let randomNumber = Math.floor(Math.random() * 101).toString()
                this.dockerName = "si-" + this.dbName + randomNumber + "-db"
                this.dockerName = this.dockerName.replace(/&/g, "")
            }
        },
        mounted() {
            this.fetchPort()
        }
    }
</script>
